<template>
  <div class="login-container">
    <div class="login-container-left">
      <div class="login-container-cover"
           style="background: url('static/images/loginlogo.png') no-repeat #fdf5f4 center;">
        <h1>红砖智库系统</h1>
      </div>
    </div>
    <div class="login-container-right">
      <div class="login-type-icon clearfix">
        <div class="login-type-qrcode" v-show="show" @click="changeToQrCodeLogin">
          <div class="login-type-tips">
            扫码登录
          </div>
          <i class="icon-erweima1 iconfont" style="font-size: 50px; color:rgb(255, 106, 80);cursor: pointer;"></i>

        </div>
        <div class="login-type-password" v-show="!show" style="display: none;" @click="changeToPasswordLogin">
          <div class="login-type-tips">
            密码登录
          </div>
          <i class="icon-saoma iconfont " style="font-size: 50px; color:rgb(255, 106, 80);cursor: pointer;"></i>
        </div>
      </div>
      <div id="password-login-container " v-show="show">
        <div class="tab">
          <div class="content">
            <div style="margin: 20px 30px 0;">
              <button :class="index == number ? 'btn1':'btn'" @click="tab(index)" v-for="(item ,index) in dataList"
                      :key="index">{{item.option}}
              </button>
            </div>
            <!--                <div :class="[number == 0 ?'login_blue_line-left':'login_blue_line-right']"></div>-->
            <div id="content1" v-show="number == 0" style="padding-top: 30px">
              <el-form class="login-form login-password">
                <el-form-item style="line-height: 15px">
                  <span style="text-align: left;float: left;line-height: 15px"><b>账号</b></span>
                  <el-input type="text" v-model="userId" id="userId" placeholder="请输入手机号码"
                            style="width: 100%"></el-input>
                </el-form-item>
                <el-form-item style="line-height: 15px" prop="password">
                  <span style="text-align: left;float: left;line-height: 15px"><b>密码</b></span>
                  <el-input type="password" v-model="password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item style="padding-right: 110px;line-height: 15px">
                  <span style="text-align: left;float: left;line-height: 15px "><b>验证码</b></span>
                  <el-input v-model="captchaCode" type="captchaCode" placeholder="请输入验证码"
                            @keyup.enter.native="loginPassword"></el-input>
                  <img :src="captchaImage" @click="refreshCaptcha"
                       style="position: absolute; width: 90px; margin-top: 4px;margin-left: 10px; position:absolute;border-bottom: 1px solid #ededed;cursor: pointer;">
                </el-form-item>
                <div style="margin-top: -20px">
                  <el-row>
                    <el-col :span="12"><el-checkbox v-model="autoLogin">自动登录</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="rememberPassWord">记住密码</el-checkbox></el-col>
                  </el-row>
                </div>
                <div style="padding: 0 20px">
                  <button type="button" class="login-button" round @click="loginPassword" :disabled="login.disabled"
                          style="color: white; font-size: 15px"><b>登录</b></button>
                </div>

              </el-form>
            </div>

            <div id="content2" v-show="number == 1" style="padding-top: 30px">
              <el-form class="login-form login-phone">
                <el-form-item style="line-height: 15px">
                  <span style="text-align: left;float: left;line-height: 15px"><b>账号</b></span>
                  <el-input type="text" v-model="phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item style="padding-right: 120px; line-height: 15px">
                  <span style="text-align: left;float: left;line-height: 15px"><b>短信验证码</b></span>
                  <el-input type="text" v-model="smsCode" placeholder="请输入短信验证码"></el-input>
                  <el-button type="info" size="small" class="smscode" :class="sms.disabled?'not-click-send':'click-send'" style="position: absolute;width: 120px;height: 40px;
                          border-style: none;border-color: unset;color: rgb(255, 255, 255);border-radius: 0px 4px 4px 0px;font-size: 14px;
                          padding: 0px;text-align: center;line-height: 20px;font-weight: normal;font-style: normal;"
                             @click="getSmsCode" :disabled="sms.disabled">{{ sms.massage }}
                  </el-button>
                </el-form-item>
                <div style="padding: 0 20px">
                  <button type="button" class="login-button" round @click="loginSmsCode" :disabled="login.disabled"
                          style="color: white; font-size: 15px"><b>登录</b></button>
                </div>
              </el-form>
            </div>

            <div id="content3" v-show="number == 2" style="padding-top: 30px">
              <el-form class="login-form login-phone" ref="retrieve-form" :model="retrieveForm" :rules="rules1">
                <el-form-item style="line-height: 15px" prop="phone">
                  <span style="text-align: left;float: left;line-height: 15px"><b>账号</b></span>
                  <el-input type="text" v-model="retrieveForm.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>

<!--                <el-form-item style="line-height: 15px">-->
<!--                  <span style="text-align: left;float: left;line-height: 15px"><b>确认密码</b></span>-->
<!--                  <el-input type="confirmPassword" v-model="confirmPassword" placeholder="请输入确认密码"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item style="padding-right: 120px; line-height: 15px">
                  <span style="text-align: left;float: left;line-height: 15px"><b>短信验证码</b></span>
                  <el-input type="text" v-model="retrieveForm.smsCode"  autocomplete="new-password" placeholder="请输入短信验证码"></el-input>
                  <el-button type="info" size="small" class="smscode" :class="sms.disabled?'not-click-send':'click-send'" style="position: absolute;width: 120px;height: 40px;
                          border-style: none;border-color: unset;color: rgb(255, 255, 255);border-radius: 0px 4px 4px 0px;font-size: 14px;
                          padding: 0px;text-align: center;line-height: 20px;font-weight: normal;font-style: normal;"
                             @click="getRetrieveSmsCode" :disabled="retrieveSms.disabled">{{ retrieveSms.massage }}
                  </el-button>
                </el-form-item>

                <el-form-item style="line-height: 15px" prop="password">
                  <span style="text-align: left;float: left;line-height: 15px"><b>新的密码</b></span>
                  <el-input show-password type="password" v-model="retrieveForm.password" placeholder="长度为10-20位，包含数字、大小写字母和字符" autocomplete="new-password"></el-input>
                </el-form-item>

                <div style="padding: 0 20px">
                  <button type="button" class="login-button"   autocomplete="new-password"  round @click="handleUpdatePwd" :disabled="retrieve.disabled"
                          style="color: white; font-size: 15px"><b>修改密码</b></button>
                </div>
              </el-form>
            </div>

          </div>
        </div>
        <div class="card-foot" style="text-align: center">
          <div clas="card-foot-left">
            <span style="font-size: 14px;">没有账号？</span>
            <el-button type="text" @click="goToRegister">立即注册</el-button>
          </div>
          <div class="card-foot-right">
            <span style="font-size: 14px">{{number === 2 ? '去登录' : '忘记密码?'}}</span>
            <el-button type="text" @click="number = 2" v-if="number !== 2">点击找回</el-button>
            <el-button type="text" @click="number = 0" v-if="number === 2">点击登录</el-button>
          </div>
        </div>
      </div>
      <div v-show="!show">
        <div class="card-header" style="margin-top: 20px;text-align: center;">
          <div class="btn1" style="text-align: center;width: 100%">扫码登录</div>
        </div>
        <div class="qr_code" style="text-align: center" v-loading="qrCodeFlag">
          <div id="qr_login" style="height: 260px;" v-show="!qrCodeFlag && !timeOutLoadingFlag"><!--<a href="javascript:void(0)" class="qr-click">刷新</a>--></div>
          <div style="height: 260px;" v-show="timeOutLoadingFlag || qrCodeFlag ">
            <a href="javascript:void(0)" @click="refreshQrCode" class="qr-click" v-if="timeOutLoadingFlag">加载超时，点击刷新</a>
          </div>
<!--          <img src="static/images/QR_Code.png" style="height: 220px;"/>-->
<!--          <br/>-->
<!--          <span style="color: #a6a6a6;">使用手机二维码扫码登录系统</span>-->
        </div>
        <div class="qrcode-card-foot" style="text-align: center">
          <div class="qrcode-card-foot-left">
            <span style="font-size: 14px">没有账号？</span>
            <el-button type="text" @click="goToRegister">立即注册</el-button>
          </div>
<!--         <div class="qrcode-card-foot-right">-->
<!--           <span style="font-size: 14px">忘记密码？</span>-->
<!--           <el-button type="text" @click="goRetrievePassword">点击找回</el-button>-->
<!--         </div>-->
        </div>
      </div>
    </div>
    <animation :loadingDataVisible="loadingDataVisible" :loadingText="loadingText"></animation>
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {mapState} from "vuex";
import encrypt from "@/utils/encryptUtils";
import {Message} from "element-ui";
import Animation from "@/components/loading/animation";
import * as constantsRules from '@/constants/constantRules'
export default {
  name: "Login",
  components: {Animation},
  data() {
    return {
      loadingDataVisible:false,
      loadingText:'',
      show: true,
      userId: '',
      password: '',
      confirmPassword:'',
      activeIndex: '1',
      captchaCode: '',
      captchaImage: '',
      phone: '',
      //通过短信认证码修改密码
      retrieveForm:{
        phone: '',
        password: '',
        smsCode: '',
        smsKey: '',
      },
      smsCode: '',
      login: {
        disabled: false,
      },
      retrieve: {
        disabled: false,
      },
      sms: {
        massage: "获取验证码",
        disabled: false,
        count: 60,
        isSendFlag:false,
      },

      retrieveSms:{
        massage: "获取验证码",
        disabled: false,
        count: 60,
        isSendFlag:false,
      },

      number: 0, //点击后的值，与下标同步，为0表示默认第一个按钮与div为选中状态
      dataList: [
        {option: '账号登录'},
        {option: '短信登录'},
      ],
      wwLogin: null,
      authCode: null,
      autoLogin: false,
      rememberPassWord: false,
      rules1: constantsRules.registerRules1,
      qrCodeFlag: true,
      checkQrCodeObj: null,
      timeOutLoadingFlag: false,
      connCount: 0
    }
  },
  created(){
    cookie.getCookie('eims_name')?this.userId = cookie.getCookie('eims_name'):'';
    if (cookie.getCookie('eims_name') && cookie.getCookie('eims_pass')) {
      this.password = encrypt.base64decode(cookie.getCookie('eims_pass'));
      this.rememberPassWord = true;
    }
  },
  watch: {
    "$route.query": {
      handler(newVal, oldVal) {

          this.authCode = this.$route.query["code"];
          this.status = this.$route.query["status"];
          if (this.authCode || this.status) {
            this.show = false
          }
          this.authCode && this.sendQrCodeLogin();

      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.refreshCaptcha();
    this.creat();
    // this.getQrCode();
    clearInterval(this.checkQrCodeObj);
  },
  methods: {

    //(主要是)校验密码参数
    validateRetrieveForm() {
      let result = false;
      this.$refs['retrieve-form'].validate((valid) => {
        if (valid) {
          result = true;
        }
      });
      return result;
    },

    getQrCode(){
      // let url = "http://eims.visionsky.com.cn/#/login"; //url一般为自己当前的登陆页面，要做一个回调获取到code
      // let url = location.origin + '/xpest/console_v2/ui/login';
      if (this.appid && this.agentid){
        let href = window.location.href;
        let number = href.indexOf('code');
        if (number>-1){
          href = href.substr(0,number-1);
        }
        this.wwLogin = new WwLogin({
          id: "qr_login",
          appid: this.appid,
          agentid: this.agentid,
          redirect_uri: encodeURIComponent(href),
          state: "hellowecom",
          href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6MjAwcHg7aGVpZ2h0OiAxODBweDt9DQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQ0K",
          lang: "zh",
        })

        this.checkQrCodeObj = setInterval(()=>{
          if (this.connCount>20){
            this.timeOutLoading();
          } else {
            if (this.wwLogin.getState()){
              this.showQRCode();
            }else {
              this.connCount += 1;
            }
          }

        },1000)
        //href属性，可加入额外样式 值如  href: "data:text/css;base64,base64加密后的字符串"
      }else {
        this.$message({
          message:'系统异常，请稍后再试',
          type: 'warning',
          showClose: true
        })
      }
    },
    refreshQrCode(){
      this.getQrCode();
    },
    showQRCode(){
      clearInterval(this.checkQrCodeObj);
      this.qrCodeFlag = false;
      this.timeOutLoadingFlag = false;
    },
    timeOutLoading(){
      clearInterval(this.checkQrCodeObj);
      this.qrCodeFlag = false;
      this.connCount = 0;
      this.timeOutLoadingFlag = true;
    },
    changeToQrCodeLogin() {
      this.qrCodeFlag = true;
      this.timeOutLoadingFlag = false;
      clearInterval(this.checkQrCodeObj);
      if (this.wwLogin) {
        this.wwLogin.destroyed();
      }
      this.getQrCode();
      this.show = !this.show;

    },
    changeToPasswordLogin() {
      clearInterval(this.checkQrCodeObj);
      this.show = !this.show
    },
    tab(index) {
      this.number = index;
    },
    creat() {
      let token = cookie.getCookie('token');
      if ((token != undefined && token.length > 0)) {
        this.$router.push({path: '/home'})
      }


    },
    phoneCheck() {
      var amPhone = /^[6]([8|6])\d{5}$/;
      var xgPhone = /^([6|9])\\d{7}$/;
      var twPhone = /^[0][9]\d{8}$/;
      var zgdlPhone = /^1[3-9]\d{9}$/;
      if (this.phone == null) {
        Message.warning("请输入手机号码!");
        return false;
      }else if (this.phone.length == 7 || this.phone.length == 8 || this.phone.length == 10 || this.phone.length == 11) {
        if (this.phone.length == 7 && this.phone.match(amPhone)==null) {
          Message.warning("请输入正确的手机号码!");
          return false;
        } else if (this.phone.length == 8 && this.phone.match(xgPhone)==null){
          Message.warning("请输入正确的手机号码!");
          return false;
        } else if (this.phone.length == 10 && this.phone.match(twPhone)==null){
          Message.warning("请输入正确的手机号码!");
          return false;
        } else if (this.phone.length == 11 && this.phone.match(zgdlPhone)==null){
          Message.warning("请输入正确的手机号码!");
          return false;
        } else {
          return true;
        }
      }else {
        Message.warning("请输入正确的手机号码!");
        return false;
      }
      return true;
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key
    },
    //获取图形验证码
    refreshCaptcha() {
      http.post(window.config.api.baseUrl + '/eims-api/user/captcha', {
        data: {
          key: this.captchaKey
        }
      }).then(response => {
        this.captchaKey = response.data.data.key;
        this.captchaImage = response.data.data.image;
      });
    },
    //通过用户名密码登录
    loginPassword() {
      if (this.login.disabled) {
        return;
      }
      this.login.disabled = true;
      if (!this.userId) {
        Message.error({message: "手机号不能为空", showClose: true});
        this.login.disabled = false;
        return;
      }
      if (!this.password) {
        Message.error({message: "密码不能为空", showClose: true});
        this.login.disabled = false;
        return;
      }
      if (!this.captchaCode) {
        Message.error({message: "验证码不能为空", showClose: true});
        this.login.disabled = false;
        return;
      }

      http.post(window.config.api.baseUrl + '/eims-api/user/loginByPassword', {
        data: {
          userId: this.userId,
          password: this.password,
          captchaKey: this.captchaKey,
          captchaCode: this.captchaCode
        }
      }).then(response => {
        let responseData = response.data;
        if (responseData.code == '00000') {
          let token = responseData.data.token;
          cookie.setCookie('token', token, null, 1800);
          if (this.rememberPassWord){
            cookie.setCookie('eims_pass',encrypt.base64encode(this.password),null,7*24*60*60);
            cookie.setCookie('eims_name',this.userId,null,7*24*60*60);
          }else {
            cookie.deleteCookie('eims_pass');
            cookie.deleteCookie('eims_name');
          }
          Message.success({message: "登录成功", showClose: true})
          this.login.disabled = false;
          this.$router.push({path: '/deptSelect'});
        }else{
          this.captchaCode = '';
          this.refreshCaptcha()
        }
        this.login.disabled = false;
      }).catch(error => {
        this.login.disabled = false;
        Message.error({message: "登录失败", showClose: true});

      });
    },
    //获取短信验证码倒计时
    getCode() {
      this.sms.massage = "重新获取(" + this.sms.count + ")";
      this.sms.count--;
      if (this.sms.count <= 0) {
        this.sms.count = 60;
        this.sms.massage = "获取验证码";
        this.sms.disabled = false;
      } else {
        this.sms.disabled = true;
        setTimeout(() => {
          this.getCode();
        }, 1000);
      }
    },

    //获取短信验证码倒计时
    getRetrieveCode() {
      this.retrieveSms.massage = "重新获取(" + this.retrieveSms.count + ")";
      this.retrieveSms.count--;
      if (this.retrieveSms.count <= 0) {
        this.retrieveSms.count = 60;
        this.retrieveSms.massage = "获取验证码";
        this.retrieveSms.disabled = false;
      } else {
        this.retrieveSms.disabled = true;
        setTimeout(() => {
          this.getRetrieveCode();
        }, 1000);
      }
    },

    getRetrieveSmsCode(){
      http.post(window.config.api.baseUrl + '/eims-api/user/smsCodeForRetrieve', {
        data: {
          userId: this.retrieveForm.phone,
        }
      }).then(response => {
        let responseDate = response.data;
        if (responseDate.code === '00000') {
          this.retrieveForm.smsKey = responseDate.data.key;
          this.getRetrieveCode();
          this.retrieveSms.disabled = false;
          this.retrieveSms.isSendFlag = true;
          Message.success({message: "短信验证码已发送", showClose: true})
        }
        this.retrieveSms.disabled = false;
      }).catch(error => {
        Message.error(error);
        this.retrieveSms.disabled = false;
      });
    },

    handleUpdatePwd(){
      if (!this.retrieveSms.isSendFlag){
        Message.error({message: "请获取短信验证码", showClose: true});
        return;
      }
      if (!this.validateRetrieveForm()) {
        return
      }
      if (!this.retrieveForm.smsCode){
        Message.error({message: "请输入短信验证码", showClose: true});
        return;
      }

      this.loadingDataVisible = true
      this.loadingText = '修改密码'

      http.post(window.config.api.baseUrl + '/eims-api/user/updatePwdBySmsCode', {
        data: {
          phone: this.retrieveForm.phone,
          smsCode: this.retrieveForm.smsCode,
          smsKey: this.retrieveForm.smsKey,
          pwd: this.retrieveForm.password,
        }
      }).then(value => {
        if (value.data.code === '00000'){
          this.number = 0;
          this.show = true;
          Message.success("密码修改成功")
        }
      }).finally(() => {
        this.loadingDataVisible = false
      })
    },

    //获取短信验证码请求
    getSmsCode() {
      this.sms.disabled = true;
      if (this.phoneCheck()) {
        http.post(window.config.api.baseUrl + '/eims-api/user/smsCode', {
          data: {
            userId: this.phone,
            key: this.smsKey
          }
        }).then(response => {
          let responseDate = response.data;
          if (responseDate.code == '00000') {
            this.smsKey = responseDate.data.key;
            this.getCode();
            this.sms.disabled = false;
            this.sms.isSendFlag = true;
            Message.success({message: "短信验证码已发送", showClose: true})
          }
          this.sms.disabled = false;
        }).catch(error => {
          Message.error(error);
          this.sms.disabled = false;
        });
      } else {
        // Message.error("请输入正确的手机格式!");
        this.sms.disabled = false;
      }
    },

    //通过短信验证码登录
    loginSmsCode() {

      if (!this.sms.isSendFlag){
        Message.error({message: "请获取短信验证码", showClose: true});
        return;
      }
      if (!this.phone) {
        Message.error({message: "手机号不能为空", showClose: true});
        return;
      }
      if (!this.smsCode) {
        Message.error({message: "短信验证码不能为空", showClose: true});
        return;
      }
      this.login.disabled = true;
      http.post(window.config.api.baseUrl + '/eims-api/user/loginBySmsCode', {
        data: {
          userId: this.phone,
          smsCode: this.smsCode,
          smsKey: this.smsKey,
        }
      }).then(response => {
        let responseData = response.data;
        if (responseData.code == '00000') {
          let token = responseData.data.token;
          cookie.setCookie('token', token, null, 1800);
          Message.success({message: "登录成功", showClose: true})
          this.login.disabled = false;
          this.$router.push({path: '/deptSelect'})
        }
        this.login.disabled = false;
      }).catch(error => {
        this.login.disabled = false;
        Message.error({message: "登录失败", showClose: true});
      });

    },

    goRetrievePassword(){
      this.$router.push({path: '/login',query: {"code": this.$route.query.code}})
      this.number = 2
    },

    goToRegister() {
        this.$emit('toRegister',{})
    },
    sendQrCodeLogin() {
      this.loadingDataVisible = true;
      this.loadingText = '企业微信\n登录中';
      http.post(window.config.api.baseUrl + '/eims-api/user/loginByQrCode', {
        data: {
          code: this.authCode,
        }
      }).then(response => {
        this.loadingDataVisible = false;
        this.loadingText = '';
        let responseData = response.data;
        if (responseData.code == '00000') {
          let token = responseData.data.token;
          cookie.setCookie('token', token, null, 1800);
          Message.success({message: "登录成功", showClose: true})
          this.$router.push({path: '/deptSelect'})
        }else {
          this.getQrCode()
        }
      }).catch(error => {
        this.loadingDataVisible = false;
        this.loadingText = '';
        this.getQrCode()
        Message.error({message: "登录失败,请重新扫码", showClose: true});
      });

    }
  },
  computed: mapState({
    appid: state => state.userModule.appid,
    agentid: state => state.userModule.agentid,
  }),
  destroyed() {
    if (this.wwLogin!=null){
      this.wwLogin.destroyed();
    }
  }
}
</script>

<style scoped>
.login-container-cover h1{
  color: rgb(253 132 112);
  margin-top: 460px;
  font-size: 54px;
  font-family: 宋体;
  color: rgba(255,106,80,1);
}

i.icon-saoma {
  color: rgb(255, 106, 80);
  font-size: 1.5em;
}

i.icon-erweima1 {
  color: rgb(255, 106, 80);
  font-size: 20px;
}

#content1, #content2 {
  font-size: 16px;
  line-height: 40px;
}

.content {
  margin: auto;
}

/*按钮样式*/
/*未选中时*/
.btn {
  font-weight: 700;
  font-size: 18px;
  background: none;
  width: 50%;
  height: 40px;
  outline: none;
  border: none;
  color: #9c8989d6;
  animation: window-lineleft 5s 3;

}

/*选中时*/
.btn1 {
  width: 50%;
  font-weight: 700;
  font-size: 18px;
  height: 40px;
  border: none;
  color: #e22000;
  outline: none;
  background: none;
  animation: window-lineright 0.3s 1;

}

.login_blue_line-left {
  margin-left: 105px;
  position: relative;
  margin-top: 6px;
  width: 48px;
  height: 2px;
  background: #ff6a50;
  animation: itmove 1s infinite;
  -webkit-animation: itmove 1s infinite;
  animation-iteration-count: 1;
}

.login_blue_line-right {
  margin-left: 315px;
  position: relative;
  margin-top: 6px;
  width: 48px;
  height: 2px;
  background: #ff6a50;
  animation: mymove 1s infinite;
  -webkit-animation: mymove 1s infinite;
  animation-iteration-count: 1; /*动画播放次数*/
}

@keyframes mymove {
  from {
    right: 210px;
  }
  to {
    right: 0px;
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/
{
  from {
    right: 210px;
  }
  to {
    right: 0px;
  }
}

@keyframes itmove {
  from {
    left: 210px;
  }
  to {
    left: 0px;
  }
}

@-webkit-keyframes itmove /*Safari and Chrome*/
{
  from {
    left: 210px;
  }
  to {
    left: 0px;
  }
}
a{
  /*position: absolute;*/
  width: 200px;
  height: 180px;
  /*background: rgba(0,0,0,.6);*/
  font-size: 14px;
  /*color: #fff;*/
  line-height: 200px;
  text-align: center;
  /*border-radius: 50%;*/
  /*top: 330px;*/
  /*left: 850px;*/
}
.qr-click{
  /*display: none;*/

}

.qr_code:hover .qr-click{
  /*display: unset;*/
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
  background-color: var(--mainbgc);
  border-color: var(--mainbgc);
}

.card-foot,.qrcode-card-foot{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.click-send{
  background: #5ed5d9;
}
.not-click-send{
  background: rgb(204, 204, 204);
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue